export const TRANSLATIONS_PT_SETTINGS_MICROSOFT = {
  "settings.microsoft.connect_button": "Conectar Microsoft",
  "settings.microsoft.connecting": "Conectando...",
  "settings.microsoft.connected_success": "Conexao com Microsoft concluida.",
  "settings.microsoft.loading_status": "Carregando estado Microsoft...",
  "settings.microsoft.no_accounts": "Nenhuma conta Microsoft conectada.",
  "settings.microsoft.selected_account": "Conta selecionada",
  "settings.microsoft.select_account": "Selecione uma conta",
  "settings.microsoft.unnamed_account": "Conta sem nome",
  "settings.microsoft.email_unavailable": "Email indisponivel",
  "settings.microsoft.invalid_account": "Identidade de conta invalida. Acoes desabilitadas.",
  "settings.microsoft.malformed_status": "A resposta de estado Microsoft e invalida. Acoes desabilitadas.",
  "settings.microsoft.status_error": "Nao foi possivel carregar o estado Microsoft.",
  "settings.microsoft.connect_error": "Nao foi possivel concluir a autenticacao Microsoft.",
  "settings.microsoft.disconnect_error": "Nao foi possivel desconectar a conta Microsoft.",
  "settings.microsoft.default_error": "Nao foi possivel definir a conta Microsoft padrao.",
  "settings.microsoft.reauthorize_error": "Nao foi possivel reautorizar a conta Microsoft.",
  "settings.microsoft.popup_blocked": "O navegador bloqueou o popup. Permita popups para continuar.",
  "settings.microsoft.sync_period_saved": "Data de inicio de sincronizacao salva.",
  "settings.microsoft.sync_period_error": "Nao foi possivel salvar a data de inicio de sincronizacao.",
  "settings.microsoft.sync_period_integer_error": "Selecione uma data valida.",
  "settings.microsoft.sync_period_range_error": "Selecione uma data entre 365 dias atras e hoje.",
  "settings.microsoft.save_sync_period": "Salvar data",
  "settings.microsoft.make_default": "Tornar padrao",
  "settings.microsoft.reauthorize": "Reautorizar",
  "settings.microsoft.disconnect": "Desconectar",
  "settings.microsoft.oauth_processing": "Processando autenticacao Microsoft...",
  "settings.microsoft.mail_preview_title": "Previa de email",
  "settings.microsoft.drive_preview_title": "Previa do Drive",
  "settings.microsoft.sharepoint_preview_title": "Previa do SharePoint",
  "settings.microsoft.no_preview_items": "Nenhum item para mostrar.",
  "settings.microsoft.table.account": "Conta",
  "settings.microsoft.table.status": "Estado",
  "settings.microsoft.table.sync_period": "Sincronizar desde",
  "settings.microsoft.table.default": "Padrao",
  "settings.microsoft.table.actions": "Acoes",
  "settings.microsoft.connected": "Conectado",
  "settings.microsoft.connection_status_title": "Estado de conexao",
  "settings.microsoft.sync_process_title": "Sincronização da conta",
  "settings.microsoft.sync.mail_sync_status": "Status sincronizacao email",
  "settings.microsoft.sync.drive_sync_status": "Status sincronizacao drive",
  "settings.microsoft.sync.last_mail_sync_at": "Ultima sincronizacao de email",
  "settings.microsoft.sync.last_drive_sync_at": "Ultima sincronizacao de drive",
  "settings.microsoft.sync.last_read_email_date": "Data do último e-mail sincronizado",
  "settings.microsoft.sync.last_sync_date": "Última sincronização",
  "settings.microsoft.sync.emails_processed": "E-mails processados",
  "settings.microsoft.sync.period": "Período de sincronização",
  "settings.microsoft.sync.not_set": "Não definido",
  "settings.microsoft.sync.all": "Todos",
  "settings.microsoft.diagnostics_title": "Diagnostico",
  "settings.microsoft.audit_title": "Auditoria e seguranca",
  "settings.microsoft.manage_access_link": "Gerenciar permissoes da conta Microsoft",
  "settings.microsoft.privacy_policy": "Politica de privacidade",
  "settings.microsoft.terms_of_service": "Termos de servico",
  "settings.microsoft.preview_unavailable": "Previa nao disponivel. O endpoint backend ainda nao esta ativo.",
  "settings.microsoft.no_mail_items": "Nenhum email para exibir.",
  "settings.microsoft.no_drive_items": "Nenhum arquivo OneDrive para exibir.",
  "settings.microsoft.no_sharepoint_items": "Nenhum arquivo SharePoint para exibir.",
  "settings.microsoft.table.subject": "Assunto",
  "settings.microsoft.table.from": "De",
  "settings.microsoft.table.received_at": "Recebido",
  "settings.microsoft.table.name": "Nome",
  "settings.microsoft.table.type": "Tipo",
  "settings.microsoft.table.size": "Tamanho",
  "settings.microsoft.table.modified": "Modificado",
  "settings.microsoft.table.location": "Localizacao",
  "settings.microsoft.table.time": "Hora",
  "settings.microsoft.table.message": "Mensagem",
  "settings.microsoft.table.scopes": "Permissoes",
  "settings.microsoft.mail_reauth_required": "Esta conta requer reautorizacao para carregar emails.",
  "settings.microsoft.drive_reauth_required": "Esta conta requer reautorizacao para carregar arquivos.",
  "settings.microsoft.reauthorize_preview": "Reautorizar",
  "settings.microsoft.mail_not_found": "Conta Microsoft nao encontrada. Verifique as configuracoes.",
  "settings.microsoft.drive_not_found": "Drive Microsoft nao encontrado.",
  "settings.microsoft.table.body_preview": "Previa",
  "settings.microsoft.table.has_attachments": "Anexos",
  "settings.microsoft.table.created_by": "Criado por",
};
